<nav fxLayout="column">
    <button mat-icon-button class="menu-icon" (click)="menuToggle.emit()" *ngIf="showClose">
        <nb-icon icon="close-outline" class="close-sidenav"></nb-icon>
    </button>
    <div class="img-wrapper">
        <img src="../../../../assets/images/logo.png" alt="logo">
    </div>
    <span class="app-title">Boost Taxi</span>
    <ng-container *ngFor="let item of menuItems">
        <ng-container *ngIf="item.submenu; else simpleLinkView">
            <nb-accordion>
                <nb-accordion-item [expanded]="item.expanded">
                    <nb-accordion-item-header>
                        <app-link-view [item]="item"></app-link-view>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <app-link-view *ngFor="let item of item.submenu" [item]="item"></app-link-view>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
        </ng-container>
        <ng-template #simpleLinkView>
            <app-link-view [item]="item"></app-link-view>
        </ng-template>
    </ng-container>
</nav>
